import { render, staticRenderFns } from "./FolderView.vue?vue&type=template&id=7c3f5ebd&scoped=true&"
import script from "./FolderView.vue?vue&type=script&lang=js&"
export * from "./FolderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3f5ebd",
  null
  
)

export default component.exports